// Common IANA timezones — covers the major North American + international hubs.
// (The browser also accepts any IANA tz string at runtime if a user adds more later.)
export const TIMEZONE_OPTIONS = [
  { value: "America/New_York", label: "Eastern (New York)" },
  { value: "America/Chicago", label: "Central (Chicago)" },
  { value: "America/Denver", label: "Mountain (Denver)" },
  { value: "America/Phoenix", label: "Mountain - no DST (Phoenix)" },
  { value: "America/Los_Angeles", label: "Pacific (Los Angeles)" },
  { value: "America/Anchorage", label: "Alaska (Anchorage)" },
  { value: "Pacific/Honolulu", label: "Hawaii (Honolulu)" },
  { value: "America/Toronto", label: "Canada Eastern (Toronto)" },
  { value: "America/Edmonton", label: "Canada Mountain (Edmonton)" },
  { value: "America/Vancouver", label: "Canada Pacific (Vancouver)" },
  { value: "America/Mexico_City", label: "Mexico (Mexico City)" },
  { value: "Europe/London", label: "United Kingdom (London)" },
  { value: "Europe/Paris", label: "Central Europe (Paris)" },
  { value: "Europe/Berlin", label: "Central Europe (Berlin)" },
  { value: "Australia/Sydney", label: "Australia Eastern (Sydney)" },
];

const SHORT = {
  "America/New_York": "Eastern", "America/Chicago": "Central", "America/Denver": "Mountain",
  "America/Phoenix": "Arizona", "America/Los_Angeles": "Pacific", "America/Anchorage": "Alaska",
  "Pacific/Honolulu": "Hawaii", "America/Toronto": "Eastern (CA)", "America/Edmonton": "Mountain (CA)",
  "America/Vancouver": "Pacific (CA)", "America/Winnipeg": "Central (CA)", "America/Regina": "Central (SK)",
  "America/Halifax": "Atlantic", "America/Mexico_City": "Mexico City", "Europe/London": "UK",
  "Europe/Paris": "Central Europe", "Europe/Berlin": "Central Europe", "Australia/Sydney": "Sydney",
};

/** "America/Chicago" → "Central"; unknown zones show their city. */
export const tzLabel = (tz) => (tz ? SHORT[tz] || tz.split("/").pop().replace(/_/g, " ") : "");

export const browserTimezone = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch { return ""; }
};
